<template>
  <v-speed-dial v-model="fab">
    <template v-slot:activator>
      <v-badge color="pink" :value="unreadEventNotify" :content="unreadEventNotify" overlap>
        <v-btn v-model="fab" fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-bell-outline</v-icon>
        </v-btn>
      </v-badge>
    </template>

    <v-card class="pa-3 d-flex flex-column" @click.stop="" :ripple="false">
      <h4>即時警報資訊</h4>
      <v-divider class="my-2" />
      <div class="overflow-y-auto" @scroll.stop="" ref="notifyList">
        <v-alert
          v-for="(item, index) in eventNotify"
          :key="index"
          border="left"
          colored-border
          elevation="2"
          class="event-notify"
          :color="(item.iat > lastEventNotifyRead ? 'error' : 'grey') + ' accent-4'"
          dense
        >
          <p>
            <time>{{ item.dt }}</time>
            <span class="site">{{ item.siteName }}</span>
          </p>
          <p>
            <span>{{ item.deviceName }}</span>
            <span>{{ item.eventType }}</span>
            <span>{{ item.eventStatus }}</span>
          </p>
          <span class="read">{{ lastEventNotifyRead > item.iat ? '已讀' : '未讀' }}</span>
        </v-alert>
      </div>
    </v-card>
  </v-speed-dial>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      fab: false,
    }
  },
  watch: {
    fab(val) {

      if (val) {
        this.$nextTick(() => {
          if (!this.$refs.notifyList) return

          this.$refs.notifyList.scrollTop = this.$refs.notifyList.scrollHeight
        })
      }
      else {
        this.eventNotifyRead()
      }
    }
  },
  computed: {
    ...mapGetters(['eventNotify', 'unreadEventNotify', 'lastEventNotifyRead'])
  },
  methods: {
    ...mapActions(['eventNotifyRead'])
  }
}
</script>

<style lang="scss" scoped>
.v-speed-dial {
  position: fixed;
  z-index: 999;
  bottom: 16px;
  right: 16px;
}
.v-card {
  position: absolute;
  bottom: 25px;
  right: -4px;
  max-width: inherit !important;
  width: 400px !important;
  height: calc(100vh - 173px);
}

.v-card--link:before {
  background: none;
}

.event-notify {
  position: relative;

  p {
    display: flex;
    justify-content: space-between;
  }

  time {
    font-size: 14px;
  }

  .site {
    font-size: 14px;
  }

  .read {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 10px;
  }
}
</style>
